import { useEffect, useRef } from "react";
import { Icone } from "./Icone.js";
import { PerguntarAIa } from "./PerguntarAIa.js";
import { IconeFechar } from "./icones.js";

/**
 * O assistente durante a sessão de estudo — RN-42, RN-62.
 *
 * **Painel próprio, irmão do painel do caderno, e nunca dentro dele.** O campo
 * de perguntar morou um tempo no fim do painel do caderno, e ali ele era um
 * apêndice de uma tela de escrita: o caderno é onde se **escreve**, o assistente
 * é onde se **pergunta**. Duas atividades, duas superfícies — e a resposta do
 * modelo só entra no caderno por um toque explícito de quem leu (RN-62), que é
 * exatamente a fronteira que some quando os dois dividem o mesmo painel.
 *
 * **Um de cada vez.** Quem decide é a tela de execução, com um estado só para os
 * dois painéis: abrir um fecha o outro por construção, sem coordenação entre
 * componentes. Os dois repartem a mesma coluna ao lado do enunciado, e duas
 * colunas de apoio não caberiam ali (ADR 022).
 *
 * **Nada é gravado sem um toque** (RN-62), e quem garante isso é o
 * `PerguntarAIa`: a resposta vive na tela até a pessoa sair. Este painel não
 * acrescenta persistência nenhuma — ele é a casca que faltava.
 *
 * **Fica desligado no simulado** (RN-55), como o do caderno: quem monta a tela
 * decide, e aqui não há verificação de modo.
 */
export function PainelDoAssistente({ itemId, aoFechar }: { itemId: string; aoFechar: () => void }) {
  const botaoFechar = useRef<HTMLButtonElement>(null);

  /*
   * O foco entra no painel ao abrir e para no "Fechar", pela mesma razão do
   * painel do caderno (RN-42): quem abriu estava com o foco no alvo do rodapé,
   * que deixa de ser montado, e sem isto o foco cairia no `body`.
   */
  useEffect(() => {
    botaoFechar.current?.focus();
  }, []);

  return (
    <aside className="painel-sessao painel-assistente" aria-label="Assistente">
      <div className="linha linha--espalhada painel-sessao__topo">
        <p className="etiqueta">Assistente</p>
        <button
          type="button"
          ref={botaoFechar}
          className="lateral__alternar"
          aria-label="Fechar o assistente"
        title="Fechar o assistente · Esc"
          onClick={aoFechar}
        >
          <Icone glifo={IconeFechar} papel="acao" />
        </button>
      </div>

      <div className="painel-sessao__corpo">
        <PerguntarAIa itemId={itemId} modo="duvida" />
      </div>
    </aside>
  );
}
